import api from './api';

export interface UnidadeMedida {
  id: string;
  codigo: string;
  descricao: string;
  ativo: boolean;
}

export type UnidadeMedidaInput = Partial<Omit<UnidadeMedida, 'id'>>;

const ENDPOINT = '/industrializacao/unidade-medida';

const unidadeMedidaService = {
  async listar(): Promise<UnidadeMedida[]> {
    const response = await api.get<UnidadeMedida[]>(ENDPOINT);
    return response.data;
  },
  async buscarPorId(id: string): Promise<UnidadeMedida> {
    const response = await api.get<UnidadeMedida>(`${ENDPOINT}/${id}`);
    return response.data;
  },
  async criar(data: UnidadeMedidaInput): Promise<UnidadeMedida> {
    const response = await api.post<UnidadeMedida>(ENDPOINT, data);
    return response.data;
  },
  async atualizar(id: string, data: UnidadeMedidaInput): Promise<UnidadeMedida> {
    const response = await api.put<UnidadeMedida>(`${ENDPOINT}/${id}`, data);
    return response.data;
  },
  async excluir(id: string): Promise<void> {
    await api.delete(`${ENDPOINT}/${id}`);
  },
};

export default unidadeMedidaService;
